import finalFantasy from "./themeFinalFantasy.module.css";
import classique from "./themeClassique.module.css";

/**
 * Registre des styles de l'écran client « saisie » : chaque style est un fichier de styles (module CSS) qui habille le même contenu
 * (mêmes noms de classes), et dit quel curseur il utilise par défaut.
 *
 * Pour ajouter un style : copier un fichier `theme<Nom>.module.css` en le renommant et en changeant les couleurs et formes, ajouter
 * une ligne ci-dessous et une option dans `OPTIONS_THEME` (reglagesSaisie.js). Rien d'autre à modifier. Voir README.md.
 *
 *   styles   : le module CSS du style
 *   curseur  : « gant » (la main dessinée) ou « triangle » (une petite flèche), quand aucune image de gant n'est choisie
 */
export const THEMES = {
    finalfantasy: {styles: finalFantasy, curseur: "gant"},
    classique: {styles: classique, curseur: "triangle"},
};

export const THEME_PAR_DEFAUT = "finalfantasy";

/** Le style demandé, ou celui d'origine si l'identifiant est inconnu (style retiré, valeur erronée). */
export function themeOuDefaut(id) {
    return Object.prototype.hasOwnProperty.call(THEMES, id) ? THEMES[id] : THEMES[THEME_PAR_DEFAUT];
}
